<button mat-raised-button color="primary" (click)="openDialog()">
    <ng-content></ng-content>
</button>
